module.exports = __webpack_public_path__ + "img/1184f.c8276a25.png";